import React from 'react';
import { IWiFi } from 'types';

interface Props {
    data: IWiFi,
    wifiRowClicked:(data:object)=> void
}
export default function WiFiList(props: Props) {

    const qualityIconHandler = () => {

        let icon = 'wifi-low'
        /* if (props.data.quality >= 0 && props.data.quality < 33)
            icon = 'wifi-low' */
        if (props.data.quality >= 34 && props.data.quality < 67)
            icon = 'wifi-medium'
        else if (props.data.quality >= 68)
            icon = 'wifi-full'

        return icon
    }

    
    return (
        <div className='flex justify-between items-center border-b border-gray-200 py-2 hover:bg-gray-100' onClick={()=>props.wifiRowClicked(props.data)}>
            <div className='flex'>
               {/*  {props.data.encrypted && <img className='ml-8 w-5' src={require(`assets/icons/${qualityIconHandler()}.svg`)} alt="" />} */}
                {props.data.encrypted && <img className='w-4' src={require(`../../assets/icons/lock.svg`).default} alt="Lock" />}
                {/*                 {props.data.encrypted && <img src={require(`../../assets/icons/${props.data.encrypted ? 'lock' : 'unlock'}.svg`)} alt="Lock" />}
 */}
            </div>
            <div className='text-left'>
                <span className='primary_text_color block primary_text_color font-medium VazirEng'>{props.data.ssid ? props.data.ssid : 'No name'}</span>
                <span dir='ltr' className='secondry_text_color VazirEng text-xs'><span>{props.data.freq}</span><span className='ml-1'>2.4 GHz</span></span>
            </div>
        </div>
    )
}
